import Checkbox from 'components/elements/atoms/Checkbox';

export default function TopicList({
  loading,
  topics,
  selectedTopics,
  onChange,
}) {
  if (loading)
    return (
      <div
        className="fa fa-spin fa-spinner text-primary spinner"
        style={{ fontSize: '16px' }}
      />
    );

  const toggle = (topic) => {
    const exists = selectedTopics.some(
      (t) => t.googleTopicId === topic.googleTopicId,
    );
    if (exists) {
      onChange(
        selectedTopics.filter((t) => t.googleTopicId !== topic.googleTopicId),
      );
    } else {
      onChange([...selectedTopics, topic]);
    }
  };

  return (
    <div>
      {topics.map((topic) => (
        <Checkbox
          className="mb-2 d-block"
          key={topic.googleTopicId}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            toggle(topic);
          }}
          checked={selectedTopics.some(
            (t) => t.googleTopicId === topic.googleTopicId,
          )}
          disabled={false}
        >
          {topic.name}
        </Checkbox>
      ))}
    </div>
  );
}
